import { createActions, createReducer } from 'reduxsauce'

export const { Types, Creators } = createActions(
	{
		setMuvicardInstallmentsQtt: ['muvicardInstallmentsQtt'],
		setMuvicardInstallmentsOptions: ['muvicardInstallmentsOptions'],
		setMuvicardInterestRate: ['muvicardInterestRate'],
	},
	{
		prefix: 'muvicard-purchase/',
	}
)

const initialState = {
	muvicardInstallmentsQtt: 1,
	muvicardInstallmentsOptions: [],
	muvicardInterestRate: 0,
}

const setMuvicardInstallmentsQtt = (
	state = initialState,
	{ muvicardInstallmentsQtt }
) => ({
	...state,
	muvicardInstallmentsQtt,
})

const setMuvicardInterestRate = (
	state = initialState,
	{ muvicardInterestRate }
) => {
	const { interest } =
		state.muvicardInstallmentsOptions[muvicardInterestRate - 1]
	return { ...state, muvicardInterestRate: interest }
}

const setMuvicardInstallmentsOptions = (
	state = initialState,
	{ muvicardInstallmentsOptions }
) => ({
	...state,
	muvicardInstallmentsOptions,
})

export default createReducer(initialState, {
	[Types.SET_MUVICARD_INSTALLMENTS_QTT]: setMuvicardInstallmentsQtt,
	[Types.SET_MUVICARD_INSTALLMENTS_OPTIONS]: setMuvicardInstallmentsOptions,
	[Types.SET_MUVICARD_INTEREST_RATE]: setMuvicardInterestRate,
})
